<div class="pt-[60px] md:pt-[80px] lg:pt-[100px] xl:pt-[150px] border-t border-gray-100 dark:border-[#172036]">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px]">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[25px]">
            <div class="ltr:xl:-mr-[35px] rtl:xl:-ml-[35px]">
                <!-- logo napparait pas en blanc en dark mode -->
                <!-- <a routerLink="/" class="inline-block max-w-[132px] mb-[20px] md:mb-[23px]">
                    <img [src]="logoSrc" alt="logo" class="inline-block">
                </a> -->
                <a routerLink="/" class="inline-block max-w-[132px] mb-[20px] md:mb-[23px]">
                    <img src="images/logo_loomisFx.png" alt="logo" class="inline-block dark:hidden">
                    <img src="images/logo_loomisFx_dark.png" alt="logo" class="hidden dark:inline-block">
                </a>
                <p class="!leading-[1.6]">
                    © Loomis FX, Gold and Services - {{currentYear}}
                </p>
                <div class="mt-[20px] md:mt-[35px]">
                    <!-- <a href="#" target="_blank" class="inline-block leading-none text-[20px] text-primary-600 transition-all hover:text-primary-500 ltr:mr-[8px] rtl:ml-[8px] ltr:last:mr-0 rtl:last:ml-0">
            <i class="ri-facebook-fill"></i>
        </a> -->
                    <!-- <a href="https://twitter.com/cpordevises" target="_blank" class="inline-block leading-none text-[20px] text-primary-600 transition-all hover:text-primary-500 ltr:mr-[8px] rtl:ml-[8px] ltr:last:mr-0 rtl:last:ml-0">
                        <i class="ri-twitter-x-fill"></i>
                    </a> -->
                    <a href="https://www.linkedin.com/company/loomis-fxgs-France" target="_blank" class="inline-block leading-none text-[20px] text-primary-600 transition-all hover:text-primary-500 ltr:mr-[8px] rtl:ml-[8px] ltr:last:mr-0 rtl:last:ml-0">
                        <i class="ri-linkedin-fill"></i>
                    </a>
                    <a href="mailto:fxgs.contact@loomis.com" target="_blank" class="inline-block leading-none text-[20px] text-primary-600 transition-all hover:text-primary-500 ltr:mr-[8px] rtl:ml-[8px] ltr:last:mr-0 rtl:last:ml-0">
                        <i class="ri-dribbble-fill"></i>
                    </a>
                </div>
            </div>

            <div class="ltr:xl:pl-[130px] rtl:xl:pr-[130px]">
                <h3 class="!leading-[1.2] !text-md md:!text-lg !mb-[18px] !font-semibold">
                    {{ 'i18n.app.features.pages.front-pages.common.fp-footer.h3_01' | translate }}
                </h3>
                <ul>
                    <li class="mb-[10px] last:mb-0">
                        <a routerLink="/" class="lg:text-md inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            {{ 'i18n.app.features.pages.front-pages.common.fp-footer.a_01' | translate }}
                        </a>
                    </li>
                    <li class="mb-[10px] last:mb-0">
                        <a routerLink="/features" class="lg:text-md inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            {{ 'i18n.app.features.pages.front-pages.common.fp-footer.a_02' | translate }}
                        </a>
                    </li>
                    <li class="mb-[10px] last:mb-0">
                        <a 
                            href="https://www.loomis-fxgs.fr"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="lg:text-md inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            {{ 'i18n.app.features.pages.front-pages.common.fp-footer.a_03' | translate }}
                        </a>
                    </li>
                    <li class="mb-[10px] last:mb-0">
                        <a routerLink="/contact" class="lg:text-md inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                           {{ 'i18n.app.features.pages.front-pages.common.fp-footer.a_04' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="ltr:xl:pl-[80px] rtl:xl:pr-[80px] lg:col-span-2">
                <h3 class="!leading-[1.2] !text-md md:!text-lg !mb-[18px] !font-semibold">
                    {{ 'i18n.app.features.pages.front-pages.common.fp-footer.h3_02' | translate }}
                </h3>
                <ul>
                    <li class="mb-[10px] last:mb-0">
                        <a routerLink="/legal/personal-data-policy" class="lg:text-md inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            {{ 'i18n.app.features.pages.front-pages.common.fp-footer.a_05' | translate }}
                        </a>
                    </li>
                    <li class="mb-[10px] last:mb-0">
                        <a routerLink="/legal/cookie-management-policy" class="cursor-pointer lg:text-md inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            {{ 'i18n.app.features.pages.front-pages.common.fp-footer.a_06' | translate }}
                        </a>
                    </li>
                    <li class="mb-[10px] last:mb-0">
                        <a routerLink="/legal/term-of-sale" class="cursor-pointer lg:text-md inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                           {{ 'i18n.app.features.pages.front-pages.common.fp-footer.a_07' | translate }}
                        </a>
                    </li>
                    <!-- <li class="mb-[10px] last:mb-0">
                        <a routerLink="." class="lg:text-md inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            {{ 'i18n.app.features.pages.front-pages.common.fp-footer.a_08' | translate }}
                        </a>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
    <div class="py-[15px] md:py-[20px] mt-[60px] md:mt-[80px] lg:mt-[100px] bg-white dark:bg-[#0c1427] text-center">
        <div class="container 2xl:max-w-[1320px] mx-auto px-[12px]">
            <p class="!leading-[1.6]">
                © <span class="text-primary-500">Loomis FxGs</span> 
                <!-- is Proudly Owned by <a href="https://envytheme.com/" target="_blank" class="text-primary-500 transition-all hover:underline">EnvyTheme</a> -->
            </p>
        </div>
    </div>
</div>
